 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"locale-en-json":"locale-en-json","locale-sq-json":"locale-sq-json"}[chunkId]||chunkId) + "." + {"chunk-01cd42d6":"7d07a7b7","chunk-038179fc":"1288bf15","chunk-11982932":"0e5beea2","chunk-16b5baf5":"48c38a40","chunk-1fc60ab9":"9e45d216","chunk-06c002b4":"b83779d6","chunk-023c44e1":"c2f3ac72","chunk-088ada1e":"47eb32c5","chunk-1af54b01":"941d5780","chunk-1f6bf4c9":"3d9414a0","chunk-22442848":"1a1c7e9a","chunk-27d4d6ea":"8e4bc4df","chunk-2b7e5c99":"4dfd70c8","chunk-3293ddb6":"5804331b","chunk-329b3b62":"e8d38f11","chunk-ec6522ba":"e87f5c6b","chunk-a5e47ac2":"272f898b","chunk-f9d53e2a":"230a086f","chunk-2d0d3e84":"ccb19c0b","chunk-30991a8d":"ec7528aa","chunk-34873bfc":"4add1c91","chunk-46f3f5d6":"7ef77909","chunk-4a5f46a6":"f127ac0b","chunk-5074b4f9":"a5ab8ed3","chunk-58001e7f":"165ebfda","chunk-2de7db51":"49b10446","chunk-5929110a":"7efe1521","chunk-5f152f07":"357ba538","chunk-67b32c3b":"39918f9f","chunk-69a6116d":"b8225f01","chunk-826d0118":"54b003b5","chunk-d4879fdc":"dd68ec5d","chunk-0fd1465c":"8361389e","chunk-4923d47f":"a401b5eb","chunk-7bfb087f":"beb219b0","chunk-a0ce77a4":"68123dbb","chunk-4c0be18d":"56b92be4","chunk-bab24616":"545d589f","chunk-fcbb3956":"fddcb691","chunk-1faca3ce":"21f8f20e","chunk-0e90662d":"e97690fe","chunk-77e63a0e":"ab43d8f0","chunk-2d0ea161":"da5f24fb","chunk-403f4586":"80cdc968","chunk-871908d0":"8632f8fd","chunk-474641c4":"6ba8a612","chunk-4fe07520":"189b96af","chunk-77b3bdf5":"6b129b5b","chunk-806093f0":"f4983dc6","chunk-24cd6b0a":"446cc42d","chunk-57b18109":"975c4f40","chunk-75146c1e":"e439e222","chunk-4d8cf753":"340e61aa","chunk-2d0bae7d":"f520a1ed","chunk-2df385cf":"d83e1ab5","chunk-2e2d0f0c":"cb617857","chunk-2e56dd50":"e1843048","chunk-30ba37b8":"1d80005f","chunk-3831c6a8":"ad6443af","chunk-3ed311d3":"a7a4fe6d","chunk-43e4561a":"f22af88c","chunk-440c0fd7":"c09308b7","chunk-46b58d2d":"349d6d19","chunk-33ff761a":"47b68102","chunk-4c2b1a1c":"63b5f3bf","chunk-50e060f4":"71f0d716","chunk-50ef5ab4":"caa17b61","chunk-559fdca4":"5896d779","chunk-69ccdade":"f1317d74","chunk-6b3fbf7c":"8b5f2040","chunk-d0c55b12":"85f861fa","chunk-de70f6fe":"97c685fe","chunk-6fbf4bce":"d8981de2","chunk-7079aaa0":"e39f2c3a","chunk-7130bc0e":"f65c15a1","chunk-894b619e":"8c44aa14","chunk-991a6bc0":"35186860","chunk-2eef654e":"c3f1c659","chunk-485f4780":"731a1928","chunk-70c7f7ad":"8ce5d12e","locale-en-json":"e36743dc","locale-sq-json":"b4edb3ae"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-01cd42d6":1,"chunk-038179fc":1,"chunk-11982932":1,"chunk-16b5baf5":1,"chunk-1fc60ab9":1,"chunk-06c002b4":1,"chunk-023c44e1":1,"chunk-088ada1e":1,"chunk-1af54b01":1,"chunk-1f6bf4c9":1,"chunk-22442848":1,"chunk-27d4d6ea":1,"chunk-2b7e5c99":1,"chunk-3293ddb6":1,"chunk-329b3b62":1,"chunk-ec6522ba":1,"chunk-a5e47ac2":1,"chunk-f9d53e2a":1,"chunk-30991a8d":1,"chunk-34873bfc":1,"chunk-5074b4f9":1,"chunk-58001e7f":1,"chunk-2de7db51":1,"chunk-5929110a":1,"chunk-5f152f07":1,"chunk-67b32c3b":1,"chunk-69a6116d":1,"chunk-826d0118":1,"chunk-d4879fdc":1,"chunk-0fd1465c":1,"chunk-4923d47f":1,"chunk-7bfb087f":1,"chunk-4c0be18d":1,"chunk-bab24616":1,"chunk-fcbb3956":1,"chunk-1faca3ce":1,"chunk-0e90662d":1,"chunk-77e63a0e":1,"chunk-403f4586":1,"chunk-871908d0":1,"chunk-474641c4":1,"chunk-4fe07520":1,"chunk-77b3bdf5":1,"chunk-806093f0":1,"chunk-24cd6b0a":1,"chunk-57b18109":1,"chunk-75146c1e":1,"chunk-4d8cf753":1,"chunk-2df385cf":1,"chunk-2e2d0f0c":1,"chunk-2e56dd50":1,"chunk-30ba37b8":1,"chunk-3831c6a8":1,"chunk-3ed311d3":1,"chunk-43e4561a":1,"chunk-440c0fd7":1,"chunk-46b58d2d":1,"chunk-33ff761a":1,"chunk-4c2b1a1c":1,"chunk-50e060f4":1,"chunk-50ef5ab4":1,"chunk-559fdca4":1,"chunk-69ccdade":1,"chunk-6b3fbf7c":1,"chunk-d0c55b12":1,"chunk-de70f6fe":1,"chunk-6fbf4bce":1,"chunk-7079aaa0":1,"chunk-7130bc0e":1,"chunk-894b619e":1,"chunk-991a6bc0":1,"chunk-2eef654e":1,"chunk-485f4780":1,"chunk-70c7f7ad":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"locale-en-json":"locale-en-json","locale-sq-json":"locale-sq-json"}[chunkId]||chunkId) + "." + {"chunk-01cd42d6":"e8c7d6a0","chunk-038179fc":"93103372","chunk-11982932":"b627f2cd","chunk-16b5baf5":"06dddc27","chunk-1fc60ab9":"c6c3d4df","chunk-06c002b4":"2aff696c","chunk-023c44e1":"d5405999","chunk-088ada1e":"01a6a2bb","chunk-1af54b01":"23e83f94","chunk-1f6bf4c9":"7bda3a42","chunk-22442848":"7c7e44ec","chunk-27d4d6ea":"7c7e44ec","chunk-2b7e5c99":"24cf2448","chunk-3293ddb6":"49830f27","chunk-329b3b62":"49830f27","chunk-ec6522ba":"2d2f2836","chunk-a5e47ac2":"30d5ef36","chunk-f9d53e2a":"9068f953","chunk-2d0d3e84":"31d6cfe0","chunk-30991a8d":"7c7e44ec","chunk-34873bfc":"1f52727f","chunk-46f3f5d6":"31d6cfe0","chunk-4a5f46a6":"31d6cfe0","chunk-5074b4f9":"da85e713","chunk-58001e7f":"509295a1","chunk-2de7db51":"3829f211","chunk-5929110a":"7c7e44ec","chunk-5f152f07":"7c7e44ec","chunk-67b32c3b":"a9b84244","chunk-69a6116d":"7c7e44ec","chunk-826d0118":"fb6379ea","chunk-d4879fdc":"1f52727f","chunk-0fd1465c":"0e468d12","chunk-4923d47f":"269ae3a4","chunk-7bfb087f":"0e468d12","chunk-a0ce77a4":"31d6cfe0","chunk-4c0be18d":"1387403d","chunk-bab24616":"392ee49c","chunk-fcbb3956":"a8a07e8d","chunk-1faca3ce":"8b358844","chunk-0e90662d":"49830f27","chunk-77e63a0e":"c9491abf","chunk-2d0ea161":"31d6cfe0","chunk-403f4586":"48b66d1b","chunk-871908d0":"49830f27","chunk-474641c4":"317cc356","chunk-4fe07520":"20664890","chunk-77b3bdf5":"1a772d18","chunk-806093f0":"b1011229","chunk-24cd6b0a":"d9da3506","chunk-57b18109":"80f263da","chunk-75146c1e":"f4d7ad3c","chunk-4d8cf753":"db7d4dbd","chunk-2d0bae7d":"31d6cfe0","chunk-2df385cf":"7c7e44ec","chunk-2e2d0f0c":"7c7e44ec","chunk-2e56dd50":"7c7e44ec","chunk-30ba37b8":"7c7e44ec","chunk-3831c6a8":"ff3d539c","chunk-3ed311d3":"26619aa9","chunk-43e4561a":"d39a8565","chunk-440c0fd7":"4305f60e","chunk-46b58d2d":"d40772f6","chunk-33ff761a":"6d47f945","chunk-4c2b1a1c":"7e21aaba","chunk-50e060f4":"7e21aaba","chunk-50ef5ab4":"ce6a770d","chunk-559fdca4":"9a05ac9e","chunk-69ccdade":"ad2b5403","chunk-6b3fbf7c":"a2435f9a","chunk-d0c55b12":"24f97d13","chunk-de70f6fe":"f4ae525b","chunk-6fbf4bce":"b10dd6b7","chunk-7079aaa0":"7c7e44ec","chunk-7130bc0e":"de37319a","chunk-894b619e":"6b2d1479","chunk-991a6bc0":"ed371c56","chunk-2eef654e":"ad178e56","chunk-485f4780":"ad178e56","chunk-70c7f7ad":"4c793e92","locale-en-json":"31d6cfe0","locale-sq-json":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
